import type { SVGProps } from 'react';

const SvgProgramMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 40 40' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_18420_5669)'>
      <path
        d='M33.8 5.19922H6.2C3.8 5.19922 2 6.99922 2 9.39922V30.3992C2 32.7992 3.8 34.5992 6.2 34.5992H34C36.4 34.5992 38.2 32.7992 38.2 30.3992V9.59922C38.2 7.19922 36.2 5.39922 34 5.39922L33.8 5.19922ZM35.4 30.3992C35.4 31.1992 34.6 31.9992 33.8 31.9992H6.2C5.4 31.9992 4.6 31.1992 4.6 30.3992V9.59922C4.6 8.79922 5.4 7.99922 6.2 7.99922H34C34.8 7.99922 35.6 8.79922 35.6 9.59922V30.5992L35.4 30.3992Z'
        fill='currentColor'
      />
      <path
        d='M31.8 26H8.20005C7.40005 26 6.80005 26.6 6.80005 27.4C6.80005 28.2 7.40005 28.8 8.20005 28.8H31.6C32.4 28.8 33 28.2 33 27.4C33 26.6 32.4 26 31.6 26H31.8Z'
        fill='currentColor'
      />
      <path
        d='M31.8 21H8.20005C7.40005 21 6.80005 21.6 6.80005 22.4C6.80005 23.2 7.40005 23.8 8.20005 23.8H31.8C32.6 23.8 33.2001 23.2 33.2001 22.4C33.2001 21.6 32.6 21 31.8 21Z'
        fill='currentColor'
      />
      <path
        d='M26.6 14.6L24.6 16.6C24.6 16.6 24.2 17 24.2 17.4C24.2 17.6 24.2 18 24.6 18.2C24.6 18.2 25 18.6 25.4 18.6C25.8 18.6 26 18.6 26.2 18.2L28.7999 15.6C28.7999 15.6 29.2 15.2 29.2 14.8C29.2 14.4 29.1999 14.2 28.7999 14L26.2 11.4C26.2 11.4 25.8 11 25.4 11C25 11 24.8 11 24.6 11.4C24.6 11.4 24.2 11.8 24.2 12.2C24.2 12.4 24.2 12.8 24.6 13L26.6 14.8V14.6Z'
        fill='currentColor'
      />
      <path
        d='M18.8 19.3992H19C19.4 19.3992 19.8 18.9992 20 18.5992L22 11.3992C22 10.7992 22 10.1992 21.2 10.1992H21C20.6 10.1992 20.2 10.5992 20 10.9992L18 18.1992C18 18.7992 18 19.3992 18.8 19.3992Z'
        fill='currentColor'
      />
      <path
        d='M14 17.9996C14 17.9996 14.4 18.3996 14.8 18.3996C15.2 18.3996 15.4 18.3996 15.6 17.9996C15.6 17.9996 16 17.5996 16 17.1996C16 16.9996 16 16.5996 15.6 16.3996L13.6 14.5996L15.6 12.5996C15.6 12.5996 16 12.1996 16 11.7996C16 11.3996 16 11.1996 15.6 10.9996C15.6 10.9996 15.2 10.5996 14.8 10.5996C14.4 10.5996 14.2 10.5996 14 10.9996L11.4 13.5996C11.4 13.5996 11 13.9996 11 14.3996C11 14.7996 11 14.9996 11.4 15.1996L14 17.7996V17.9996Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_18420_5669'>
        <rect width={40} height={40} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgProgramMd;
